export function exchangeMessageModel(raw) {
  let defaultObject = {
    event: 'on-ct-frame-exchange',
    payload: {},
  };

  if (!raw) {
    return defaultObject;
  }

  return {
    event: raw.event || defaultObject.event,
    payload: raw.payload || defaultObject.payload,
  };
}
